export const ACTIONS = {
  VIEW: 'VIEW'
}

export const SUBJECTS = {
  VENDOR: 'VENDOR'
}
